import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import KapalService from '../../../../services/kapal/KapalService'
import { getCurrentDateFormatted } from '../../../../utilities/Utils'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalAuditKecukupan = ({ showAudit, handleCloseAudit, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])

    const [listDokAudit, setListDokAudit] = useState([])
    const [hasilAuditDok, setHasilAuditDok] = useState([])

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            try {
                const resRefDok = await kapalService.listJenisDokKapal(null, 'aud', 0, 10)
                setListDokAudit(resRefDok.data.data)

                const resHasilAudit = await kapalService.listAuditKecukupan(dataPpmKapal.nomorAjuKapal)
                if (resHasilAudit) {
                    const hasilAudit = resHasilAudit.data.data[0]
                    setValueCatatan(hasilAudit.catatan)

                    const resHasilAuditDok = await kapalService.listAuditKecukupanDok(hasilAudit.idInspeksiAudit)
                    // console.log(resHasilAuditDok.data.data)
                    setHasilAuditDok(resHasilAuditDok.data.data)
                }
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, dataPpmKapal])

    const [valueCatatan, setValueCatatan] = useState(null)
    const [valueTglAudit, setValueTglAudit] = useState(getCurrentDateFormatted())

    const onChangeTglAudit = e => {
        setValueTglAudit(e.target.value)
    }

    const onChangeCatatan = e => {
        // console.log(hasilAuditDok)
        setValueCatatan(e.target.value)
    }

    const handleChangeRadioSesuai = (id, value) => {
        setHasilAuditDok((prev) => {
            const existing = prev.find((item) => item.idJenisDok === id);
            if (existing) {
                return prev.map((item) =>
                    item.idJenisDok === id ? { ...item, isTersedia: value } : item
                );
            } else {
                return [...prev, { idJenisDok: id, keterangan: null, isTersedia: value }];
            }
        });
    }

    const handleChangeKeteranganSesuai = (id, value) => {
        setHasilAuditDok((prev) => {
            const existing = prev.find((item) => item.idJenisDok === id);
            if (existing) {
                return prev.map((item) =>
                    item.idJenisDok === id ? { ...item, keterangan: value } : item
                );
            } else {
                return [...prev, { idJenisDok: id, isTersedia: null, keterangan: value }];
            }
        });
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            let jsonAudit = {
                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                nipPetugas: localStorage.getItem('username'),
                nmPetugas: localStorage.getItem('nama'),
                catatan: valueCatatan,
                tglAudit: valueTglAudit,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date()
            }
            const resSaveAudit = await kapalService.saveAuditKecukupan(jsonAudit)
            if (resSaveAudit.data.kode === '200') {
                //ev permohonan dok
                const idInspeksiAudit = resSaveAudit.data.id

                hasilAuditDok.map(async (auditDok) => {
                    let newAuditDok = {
                        ...auditDok,
                        idInspeksiAudit: idInspeksiAudit,
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        createdBy: localStorage.getItem('userId'),
                        createdDate: new Date()
                    }
                    await kapalService.saveAuditKecukupanDok(newAuditDok)
                })

                let dataDispo = {
                    ...dataDisposisi,
                    noTugas: 'Audit-' + dataPpmKapal.nomorAjuKapal,
                    tglTugas: new Date()
                }
                await kapalService.savePenugasan(dataDispo)
                
                setShowConfirmProses(false)
                setShowProsesSuccess(true)
            } else {
                setShowConfirmProses(false)
                setShowProsesFailed(true)
            }
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        handleCloseAudit()
    }

    return (
        <>
            <Modal
                show={showAudit}
                onHide={handleCloseAudit}
                size='xl'
                centered
                scrollable
            >
                <Modal.Header>
                    <Modal.Title><h5>Audit Kecukupan (Desk Audit)</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.jenisKapal === '1' ? 'Penangkap' : 'Pengangkut'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Fasilitas Pembeku</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.fasilitasPembeku === '1' ? 'Dengan alat pembeku (freezer fishing vessel)' : 'Tanpa alat pembeku (non freezer fishing vessel)'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Audit</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type='date' placeholder="Tanggal Audit" className="form-control-sm" value={valueTglAudit} onChange={onChangeTglAudit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <h6>Checklist Audit Kecukupan</h6>
                        </div>
                    </div>
                    {
                        listDokAudit &&
                        listDokAudit.map((dokwajib, idx) => {
                            const current = hasilAuditDok.find((h) => h.idJenisDok === dokwajib.id)

                            return (
                                <>
                                    <div className='row' key={dokwajib.id || idx}>
                                        <div className='col-12'>
                                            <Form>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">{dokwajib.jenisDokKapal}</Form.Label>
                                                    <Col sm="4">
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input"
                                                                type="radio"
                                                                name={'inlineRadio' + dokwajib.id}
                                                                id={'inlineRadio' + dokwajib.id}
                                                                value="1"
                                                                checked={current?.isTersedia === "1"}
                                                                onChange={(e) => handleChangeRadioSesuai(dokwajib.id, e.target.value)}
                                                            />
                                                            <label class="form-check-label" for={'inlineRadio' + dokwajib.id}>Tersedia</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input"
                                                                type="radio"
                                                                name={'inlineRadio' + dokwajib.id}
                                                                id={'inlineRadio' + dokwajib.id}
                                                                value="0"
                                                                checked={current?.isTersedia === "0"}
                                                                onChange={(e) => handleChangeRadioSesuai(dokwajib.id, e.target.value)}
                                                            />
                                                            <label class="form-check-label" for={'inlineRadio' + dokwajib.id}>Tidak Tersedia</label>
                                                        </div>
                                                    </Col>
                                                    <Col sm="3">
                                                        <Form.Control type='text'
                                                            placeholder="keterangan"
                                                            className="form-control-sm"
                                                            onChange={(e) => handleChangeKeteranganSesuai(dokwajib.id, e.target.value)}
                                                            value={current?.keterangan}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </Form>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Catatan</Form.Label>
                                    <Col sm="8">
                                        <Form.Control as="textarea" placeholder="Catatan" className="form-control-sm" value={valueCatatan} onChange={onChangeCatatan} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses Audit Kecukupan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalAuditKecukupan